import { React, useState, useEffect, useRef } from "react";
import contestlogo from "../assets/contestlogo.png";
import contestlogobig from "../assets/contestlogobig.png";
import StepFormm from "../components/stepform";
import Gallery from "../components/Gallery"
import { Tooltip, Typography, Button } from "@material-tailwind/react";
import "../index.css";
import { createClient } from "@supabase/supabase-js";
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';
import { Pagination } from 'swiper/modules';


const supabaseUrl = "https://mzovfnxteplyeeckgsyj.supabase.co";
const supabaseKey =
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im16b3Zmbnh0ZXBseWVlY2tnc3lqIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MTMwMzg2ODIsImV4cCI6MjAyODYxNDY4Mn0.khPxrT2ESnpGSMSryIXRrZn_K9ke6vT5nCldiM-i0wo";
const supabase = createClient(supabaseUrl, supabaseKey);

function Contest() {
  const [showModal, setShowModal] = useState(false);
  const screenWidth = window.innerWidth;
  const [total, setTotal] = useState(null);
  const winnersSet1 = [
    { name: "Khushi Tilwani", location: "Ahmedabad", imgurl: "https://i.postimg.cc/qRhbcBvn/Khushi-Tilwani.jpg" },
    { name: "Upashana Sarkar", location: "Bangalore", imgurl: "https://i.postimg.cc/PxgwjRgp/Screenshot-2024-06-17-at-1-46-41-PM.png" },
    { name: "Tanishqa", location: "Bathinda", imgurl: "https://i.postimg.cc/9QwjkXdB/image.png" },
    { name: "SHRADHA PAL", location: "Gurgaon", imgurl: "https://i.postimg.cc/tCHSPjQZ/SHRADHA-PAL.jpg" },
    { name: "Puja Samanta", location: "Howrah", imgurl: "https://i.postimg.cc/J0HGY5tr/Screenshot-2024-06-17-at-1-46-05-PM.png" },
    { name: "Alisha Fahim", location: "Lucknow", imgurl: "https://i.postimg.cc/L6zW0sB3/Alisha-Fahim.jpg" },
    { name: "Priyali Shende", location: "Mumbai", imgurl: "https://i.postimg.cc/hvYjRyfz/Screenshot-2024-06-17-at-1-51-55-PM.png" },
    { name: "Nisha Kumari", location: "Patna", imgurl: "https://i.postimg.cc/R0bpnJ44/Nisha-Kumari.jpg" },
    { name: "Ritika", location: "New Delhi", imgurl: "https://i.postimg.cc/L5jx7yf8/Ritika.jpg" },
    { name: "Bhoomi Gupta", location: "Jaipur", imgurl: "https://i.postimg.cc/pLRSNtsb/Bhoomi-Gupta.png" },

  ];
  const winnersSet2 = [

    { name: "Alpa ben Chavda", location: "Rajkot", imgurl: "https://i.postimg.cc/rw0dZzpG/01-Alpa.jpg" },
    { name: "Chetna bhatti", location: "Surat", imgurl: "https://i.postimg.cc/6pvr2MCN/02-Chetna-Bhatti.png" },
    { name: "Khushi", location: "Delhi", imgurl: "https://i.postimg.cc/Wpx6NRJ7/03-Khushi.png" },
    { name: "Shreya", location: "Ballia, UP", imgurl: "https://i.postimg.cc/02gDgpLW/04-Shreya-faceless.jpg" },
    { name: "Shruti-Amin", location: "Mumbai", imgurl: "https://i.postimg.cc/YCqgHVn0/image.png" },
    { name: "Muskan-Suman", location: "Sonipat", imgurl: "https://i.postimg.cc/L5jZ6VSy/Screenshot-2024-06-17-at-1-46-22-PM.png" },
    { name: "Khushbu Bardia", location: "Hyderabad ", imgurl: "https://i.postimg.cc/TPTJzrWM/07-Khushbu.jpg" },
    { name: "Ankita Aghicha ", location: "nagpur", imgurl: "https://i.postimg.cc/2jL9F7Q2/08-Ankita-Aghicha.png" },
    { name: "Namrata", location: "Sangli", imgurl: "https://i.postimg.cc/mrhyZTV8/09-Namrata.jpg" },
    { name: "Anushree Bhattacharya", location: "Prayagraj, UP", imgurl: "https://i.postimg.cc/mDCMhk9N/10-Anushree-Bhattacharya.png" },

  ];

  const winnersSet3 = [

    { name: "Himanshi Verma", location: "West Delhi", imgurl: "https://i.postimg.cc/NLh85dhw/01-Himanshi-Verma.jpg" },
    { name: "Tivrata", location: "Mendarda, Guj", imgurl: "https://i.postimg.cc/jjvhZ6fz/02-Tivrata.jpg" },
    { name: "Priti agrawal	", location: "Kota", imgurl: "https://i.postimg.cc/vTxLYpNz/03-Priti-agrawal.jpg" },
    { name: "Nikita", location: "Haryana", imgurl: "https://i.postimg.cc/PxxQcLb0/04-Nikita.jpg" },
    { name: "Neelam", location: "Delhi", imgurl: "https://i.postimg.cc/x1DgC1Yb/05-Neelam.jpg" },
    { name: "Shivani Katoch", location: "Palampur", imgurl: "https://i.postimg.cc/SQPDBGvd/06-Shivani-Katoch.jpg" },
    { name: "Ancy A R", location: "Kerala ", imgurl: "https://i.postimg.cc/Gt4zBBHv/07-Ancy-A-R.jpg" },
    { name: "Payal bhavnani", location: "Jaipur", imgurl: "https://i.postimg.cc/XYfLy671/08-Payal-bhavnani.jpg" },
    { name: "Riddha Ritajna Bharali	", location: "Nagaon, Assam", imgurl: "https://i.postimg.cc/c48X0nqS/09-riddha-ritajna-bharali.jpg" },
    { name: "Haripriya", location: "Nellore, Andhra Pradesh	", imgurl: "https://i.postimg.cc/26c28d8z/10-Haripriya.jpg" },

  ];

  const winnersSet4 = [

    { name: "Alpa ben Chavda", location: "Rajkot", imgurl: "https://t4.ftcdn.net/jpg/00/64/67/27/360_F_64672736_U5kpdGs9keUll8CRQ3p3YaEv2M6qkVY5.jpg" },
    { name: "Chetna bhatti", location: "Surat", imgurl: "https://t4.ftcdn.net/jpg/00/64/67/27/360_F_64672736_U5kpdGs9keUll8CRQ3p3YaEv2M6qkVY5.jpg" },
    { name: "Khushi", location: "Delhi", imgurl: "https://t4.ftcdn.net/jpg/00/64/67/27/360_F_64672736_U5kpdGs9keUll8CRQ3p3YaEv2M6qkVY5.jpg" },
    { name: "Shreya", location: "Ballia, UP", imgurl: "https://t4.ftcdn.net/jpg/00/64/67/27/360_F_64672736_U5kpdGs9keUll8CRQ3p3YaEv2M6qkVY5.jpg" },
    { name: "Shruti-Amin", location: "Mumbai", imgurl: "https://t4.ftcdn.net/jpg/00/64/67/27/360_F_64672736_U5kpdGs9keUll8CRQ3p3YaEv2M6qkVY5.jpg" },
    { name: "Muskan-Suman", location: "Sonipat", imgurl: "https://t4.ftcdn.net/jpg/00/64/67/27/360_F_64672736_U5kpdGs9keUll8CRQ3p3YaEv2M6qkVY5.jpg" },
    { name: "Khushbu Bardia", location: "Hyderabad ", imgurl: "https://t4.ftcdn.net/jpg/00/64/67/27/360_F_64672736_U5kpdGs9keUll8CRQ3p3YaEv2M6qkVY5.jpg" },
    { name: "Ankita Aghicha ", location: "nagpur", imgurl: "https://t4.ftcdn.net/jpg/00/64/67/27/360_F_64672736_U5kpdGs9keUll8CRQ3p3YaEv2M6qkVY5.jpg" },
    { name: "Namrata", location: "Sangli", imgurl: "https://t4.ftcdn.net/jpg/00/64/67/27/360_F_64672736_U5kpdGs9keUll8CRQ3p3YaEv2M6qkVY5.jpg" },
    { name: "Anushree Bhattacharya", location: "Prayagraj, UP", imgurl: "https://t4.ftcdn.net/jpg/00/64/67/27/360_F_64672736_U5kpdGs9keUll8CRQ3p3YaEv2M6qkVY5.jpg" },

  ];


  const winnersList = [
    { name: "Khushi Tilwani", location: "Ahmedabad", imgurl: "https://i.postimg.cc/qRhbcBvn/Khushi-Tilwani.jpg", color: "#4B0C17" },
    { name: "Upashana Sarkar", location: "Bangalore", imgurl: "https://i.postimg.cc/PxgwjRgp/Screenshot-2024-06-17-at-1-46-41-PM.png", color: "#4B0C17" },
    { name: "Tanishqa", location: "Bathinda", imgurl: "https://i.postimg.cc/9QwjkXdB/image.png", color: "#4B0C17" },
    { name: "SHRADHA PAL", location: "Gurgaon", imgurl: "https://i.postimg.cc/tCHSPjQZ/SHRADHA-PAL.jpg", color: "#4B0C17" },
    { name: "Puja Samanta", location: "Howrah", imgurl: "https://i.postimg.cc/J0HGY5tr/Screenshot-2024-06-17-at-1-46-05-PM.png", color: "#4B0C17" },
    { name: "Alisha Fahim", location: "Lucknow", imgurl: "https://i.postimg.cc/L6zW0sB3/Alisha-Fahim.jpg", color: "#4B0C17" },
    { name: "Priyali Shende", location: "Mumbai", imgurl: "https://i.postimg.cc/hvYjRyfz/Screenshot-2024-06-17-at-1-51-55-PM.png", color: "#4B0C17" },
    { name: "Nisha Kumari", location: "Patna", imgurl: "https://i.postimg.cc/R0bpnJ44/Nisha-Kumari.jpg", color: "#4B0C17" },
    { name: "Ritika", location: "New Delhi", imgurl: "https://i.postimg.cc/L5jx7yf8/Ritika.jpg", color: "#4B0C17" },
    { name: "Bhoomi Gupta", location: "Jaipur", imgurl: "https://i.postimg.cc/pLRSNtsb/Bhoomi-Gupta.png", color: "#4B0C17" },
    { name: "Alpa ben Chavda", location: "Rajkot", imgurl: "https://i.postimg.cc/rw0dZzpG/01-Alpa.jpg", color: "#4B0C17" },
    { name: "Chetna bhatti", location: "Surat", imgurl: "https://i.postimg.cc/FskzgpJ1/image.png", color: "#4B0C17" },
    { name: "Khushi", location: "Delhi", imgurl: "https://i.postimg.cc/Wpx6NRJ7/03-Khushi.png", color: "#4B0C17" },
    { name: "Shreya", location: "Ballia, UP", imgurl: "https://i.postimg.cc/02gDgpLW/04-Shreya-faceless.jpg", color: "#4B0C17" },
    { name: "Shruti-Amin", location: "Mumbai", imgurl: "https://i.postimg.cc/YCqgHVn0/image.png", color: "#4B0C17" },
    { name: "Muskan-Suman", location: "Sonipat", imgurl: "https://i.postimg.cc/L5jZ6VSy/Screenshot-2024-06-17-at-1-46-22-PM.png", color: "#4B0C17" },
    { name: "Khushbu Bardia", location: "Hyderabad ", imgurl: "https://i.postimg.cc/TPTJzrWM/07-Khushbu.jpg", color: "#4B0C17" },
    { name: "Ankita Aghicha ", location: "nagpur", imgurl: "https://i.postimg.cc/2jL9F7Q2/08-Ankita-Aghicha.png", color: "#4B0C17" },
    { name: "Namrata", location: "Sangli", imgurl: "https://i.postimg.cc/mrhyZTV8/09-Namrata.jpg" , color: "#4B0C17"},
    { name: "Anushree Bhattacharya", location: "Prayagraj, UP", imgurl: "https://i.postimg.cc/mDCMhk9N/10-Anushree-Bhattacharya.png", color: "#4B0C17" },
    { name: "Himanshi Verma", location: "West Delhi", imgurl: "https://i.postimg.cc/NLh85dhw/01-Himanshi-Verma.jpg" , color: "#4B0C17" },
    { name: "Tivrata", location: "Mendarda, Guj", imgurl: "https://i.postimg.cc/jjvhZ6fz/02-Tivrata.jpg" , color: "#4B0C17" },
    { name: "Priti agrawal	", location: "Kota", imgurl: "https://i.postimg.cc/vTxLYpNz/03-Priti-agrawal.jpg" , color: "#4B0C17" },
    { name: "Nikita", location: "Haryana", imgurl: "https://i.postimg.cc/PxxQcLb0/04-Nikita.jpg" , color: "#4B0C17" },
    { name: "Neelam", location: "Delhi", imgurl: "https://i.postimg.cc/x1DgC1Yb/05-Neelam.jpg" , color: "#4B0C17" },
    { name: "Shivani Katoch", location: "Palampur", imgurl: "https://i.postimg.cc/SQPDBGvd/06-Shivani-Katoch.jpg" , color: "#4B0C17" },
    { name: "Ancy A R", location: "Kerala ", imgurl: "https://i.postimg.cc/Gt4zBBHv/07-Ancy-A-R.jpg" , color: "#4B0C17" },
    { name: "Payal bhavnani", location: "Jaipur", imgurl: "https://i.postimg.cc/XYfLy671/08-Payal-bhavnani.jpg" , color: "#4B0C17" },
    { name: "Riddha Ritajna Bharali	", location: "Nagaon, Assam", imgurl: "https://i.postimg.cc/c48X0nqS/09-riddha-ritajna-bharali.jpg" , color: "#4B0C17" },
    { name: "Haripriya", location: "Nellore, Andhra Pradesh	", imgurl: "https://i.postimg.cc/26c28d8z/10-Haripriya.jpg" , color: "#4B0C17" },

  ];
  

  useEffect(() => {
    async function fetchTotal() {
      const { data, error, count } = await supabase
        .from("users")
        .select("id", { count: "exact" });

      if (error) {
        console.error("Error fetching data:", error.message);
      } else {
        setTotal(count);
      }
    }

    fetchTotal();
  }, []);

  
    const [showPopup, setShowPopup] = useState(false);
  
    const names = [
      'Alice', 'Bob', 'Charlie', 'David', 'Eva',
      'Frank', 'Grace', 'Hannah', 'Ivy', 'Jack',
      'Kate', 'Liam', 'Mia', 'Noah', 'Olivia',
      'Paul', 'Quincy', 'Rachel', 'Sam', 'Tina'
    ];
  
    const togglePopup = () => {
      setShowPopup(!showPopup);
    };

  return (
    <>
    <nav className="fixed bottom-0 left-0 right-0 z-[99999] bg-white border-t-[1px] border-pink-400">
      <div className="container px-4 py-4 mx-auto">
        {/* Centered logo */}
        <div className="flex items-center justify-center">
          <a href="https://juicecosmetics.in"><img src="https://juicecosmetics.in/cdn/shop/files/Logo_95x.png?v=1686809278" alt="Logo" className="h-8 mr-16 md:h-10" /></a>
          <a href="https://juice-cosmetics.vercel.app">
          <img src="https://i.postimg.cc/Z55zX6HC/Asset-6-2x.png" alt="Logo" className="h-8 md:h-10" />
          </a>
        </div>
      </div>
    </nav>

      <div className="font-montserrat font-bold text-[#808080]  flex flex-col pt-6 ">
      
        {/* <div className="flex items-center justify-center mt-5 mb-2 text-2xl leading-tight text-center md:mt-4">
          <h1>
            {" "}
            wish to be the
            <br />
            <span
              className=" text-4xl font-[800] font-montserratbold 
          leading-tight tracking-tighter
          bg-gradient-to-br from-[#7a0242] via-[#f32d9a] via-[#dc497a]  to-[#4dfc03] inline-block text-transparent bg-clip-text "
            >
              SHINING FACE
            </span>
            <br />
            of our brand?
          </h1>
        </div>
        
        <div className="flex justify-center inline-block px-4 py-3 ">
          <p className="text-center border-2 border-[#8237B6]  border-x-0 p-2 text-sm">
            We are looking for our beauty muse <br /> and participating in this
            contest could be your once in a lifetime chance!{" "}
          </p>
        </div> */}

        <div className="flex flex-col justify-center items-center mx-auto w-full md:w-[50%] pt-6 overflow-hidden">
          {screenWidth < 768 ? ( // Render small screen image if screen width is less than 768px
            <img src={contestlogo} alt="" />
          ) : (
            // Render large screen image if screen width is 768px or more
            <img src={contestlogobig} alt="" />
          )}

          <div className="pt-10 sm:pt-2 relative -top-[13rem] mx-auto flex flex-col w-full justify-center text-center ">
            <p className=" text-md md:text-2xl ">
              {" "}
              From your wish to your <br /> personalized
              <span className="font-montserratbold text-lg text-[#8237B6] ml-1">
                NAIL POLISH!
              </span>
            </p>
            </div>
            <div class="sm:pt-2 relative mx-auto flex flex-col w-full justify-center text-center -top-[10rem]">

  
            
            <div class=" mb-5 mt-20 relative -rotate-3 flex w-full bg-[#d13a8b] ">
              <div class="py-1 text-sm animate-infinite-scroll whitespace-nowrap text-white  font-montserrat-reg" >
                <span class="sm:text-2xl mx-2">2000+ Entries Received • Thank You for Participating!</span> •
                <span class="sm:text-2xl mx-2">2000+ Entries Received • Thank You for Participating!</span> •
                <span class="sm:text-2xl mx-2">2000+ Entries Received • Thank You for Participating!</span> •
                <span class="sm:text-2xl mx-2">2000+ Entries Received • Thank You for Participating!</span> •
                <span class="sm:text-2xl mx-2">2000+ Entries Received • Thank You for Participating!</span> •
                <span class="sm:text-2xl mx-2">2000+ Entries Received • Thank You for Participating!</span> •
                <span class="sm:text-2xl mx-2">2000+ Entries Received • Thank You for Participating!</span> •
                <span class="sm:text-2xl mx-2">2000+ Entries Received • Thank You for Participating!</span> •
                <span class="sm:text-2xl mx-2">2000+ Entries Received • Thank You for Participating!</span> •
                <span class="sm:text-2xl mx-2">2000+ Entries Received • Thank You for Participating!</span> •
                <span class="sm:text-2xl mx-2">2000+ Entries Received • Thank You for Participating!</span> •
                <span class="sm:text-2xl mx-2">2000+ Entries Received • Thank You for Participating!</span> •
                <span class="sm:text-2xl mx-2">2000+ Entries Received • Thank You for Participating!</span> •
                <span class="sm:text-2xl mx-2">2000+ Entries Received • Thank You for Participating!</span> •
              </div>
            </div>
            <h1 className="mt-2 md:text-2xl text-lg justify-center text-center my-6">
              <span
                className="text-2xl font-montserratbold 
            leading-tight tracking-tighter
            bg-gradient-to-br from-[#7a0242] via-[#f32d9a] via-[#f7568b]  to-[#4dfc03] inline-block text-transparent bg-clip-text  "
              >
                The contest has concluded!
              </span>
              <p className="mx-auto mt-1 text-sm text-gray-600 font-montserrat-reg sm:text-lg">
              40 Winners Declared
          </p>
          <div className="mx-auto grid grid-cols-10 p-4 gap-2 rounded-full">
  {winnersList.map((winner, index) => (
    <div
      key={index}
      className=" bg-gray-200 w-8 rounded-full items-center justify-center"
    >
      <img src={winner.imgurl} alt={winner.name} className="w-8 h-8 rounded-full object-cover" />
    </div>
  ))}
</div>
<Button
  className="flex justify-center items-center bg-pink-500 justify-center mx-auto my-4 mb-10 "
  onClick={() => setShowModal(true)}
  
>
  Full Winners List
</Button>
              {/* <p className="mx-auto mt-4 text-sm text-gray-600 font-montserrat-reg sm:text-lg">
              10 Winners To Go
          </p>
          <div className="mx-auto grid grid-cols-10 p-4 gap-2 rounded-full">
        {[...Array(10)].map((_, index) => (
          <div
            key={index}
            className="w-8 h-8 bg-gray-200 rounded-full text-sm flex items-center justify-center"
          >?
          </div>
        ))}
      </div> */}


            </h1>
            {/* <h1 className="mb-4 md:text-2xl">
            <p className="mx-auto mt-1 text-sm text-gray-600 font-montserrat-reg sm:text-lg">
              Could you be the
          </p>
              <span
                className="text-2xl font-montserratbold 
            leading-tight tracking-tighter
            bg-gradient-to-br from-[#7a0242] via-[#f32d9a] via-[#f7568b]  to-[#4dfc03] inline-block text-transparent bg-clip-text  "
              >
                SHINING FACE OF JUICE?
              </span>
             
            </h1> */}
            {/* <h1 className="mt-4 md:text-2xl">
              <span
                className="text-3xl font-montserratbold 
            leading-tight tracking-tighter
            bg-gradient-to-br from-[#7a0242] via-[#f32d9a] via-[#f7568b]  to-[#4dfc03] inline-block text-transparent bg-clip-text  "
              >
                FOLLOW
              </span>
              <p className="mx-auto mt-1 text-sm text-gray-600 font-montserrat-reg sm:text-lg">
              these simple steps
          </p>
              <p className="mx-auto mt-1 text-sm text-gray-600 font-montserrat-reg sm:text-lg">
              and send in your entries
          </p>
            </h1> */}
        <Gallery/>



        {/* <StepFormm /> */}
        <div class="w-[90%] container mx-6 px-4 mt-10 gap-4 flex flex-col text-start  md:flex-row md:justify-center lg:w-[60%] lg:mx-auto">
 
 <div class="relative flex flex-col  text-white bg-red-500 shadow-md bg-clip-border rounded-xl ">
   <div class="p-6">
     <svg
       className="w-20 h-20 mb-4"
       viewBox="0 0 40 40"
       fill="none"
       xmlns="http://www.w3.org/2000/svg"
     >
       <path
         opacity="0.15"
         d="M7.33203 33.6666C7.33203 33.9318 8.56119 34.1862 10.7491 34.3737C12.937 34.5613 15.9045 34.6666 18.9987 34.6666C22.0929 34.6666 25.0604 34.5613 27.2483 34.3737C29.4362 34.1862 30.6654 33.9318 30.6654 33.6666C30.6654 33.4014 29.4362 33.1471 27.2483 32.9595C25.0604 32.772 22.0929 32.6666 18.9987 32.6666C15.9045 32.6666 12.937 32.772 10.7491 32.9595C8.56119 33.1471 7.33203 33.4014 7.33203 33.6666Z"
         fill="#45413C"
       />
       <path
         d="M18.1187 21.8534L6.33203 17.7267V28.92C6.33258 29.0578 6.37582 29.1921 6.45581 29.3043C6.5358 29.4165 6.64861 29.5012 6.7787 29.5467L18.112 33.5467C18.6827 33.7402 19.3013 33.7402 19.872 33.5467L31.2054 29.5467C31.3355 29.5012 31.4483 29.4165 31.5282 29.3043C31.6082 29.1921 31.6515 29.0578 31.652 28.92V17.7267L19.8787 21.8534C19.3089 22.0525 18.6885 22.0525 18.1187 21.8534Z"
         fill="#FF866E"
       />
       <path
         d="M19.8787 21.8534C19.3089 22.0525 18.6885 22.0525 18.1187 21.8534L6.33203 17.7267V21.06L18.1187 25.1867C18.6885 25.3859 19.3089 25.3859 19.8787 25.1867L31.6654 21.06V17.7267L19.8787 21.8534Z"
         fill="#FF6242"
       />
       <path
         d="M18.1187 21.8534L6.33203 17.7267V28.92C6.33258 29.0578 6.37582 29.1921 6.45581 29.3043C6.5358 29.4165 6.64861 29.5012 6.7787 29.5467L18.112 33.5467C18.6827 33.7402 19.3013 33.7402 19.872 33.5467L31.2054 29.5467C31.3355 29.5012 31.4483 29.4165 31.5282 29.3043C31.6082 29.1921 31.6515 29.0578 31.652 28.92V17.7267L19.8787 21.8534C19.3089 22.0525 18.6885 22.0525 18.1187 21.8534Z"
         stroke="#45413C"
         stroke-width="0.666667"
         stroke-linecap="round"
         stroke-linejoin="round"
       />
       <path
         d="M19 32.4933V23.4933"
         stroke="#E04122"
         stroke-width="0.666667"
         stroke-linecap="round"
         stroke-linejoin="round"
       />
       <path
         d="M18.1213 17.1867L5.66797 12.8267V17.02C5.66852 17.1578 5.71176 17.2921 5.79175 17.4043C5.87174 17.5165 5.98454 17.6012 6.11464 17.6467L18.1146 21.8533C18.6844 22.0525 19.3049 22.0525 19.8746 21.8533L31.8746 17.6467C32.0047 17.6012 32.1175 17.5165 32.1975 17.4043C32.2775 17.2921 32.3208 17.1578 32.3213 17.02V12.8267L19.8813 17.1867C19.3115 17.3858 18.6911 17.3858 18.1213 17.1867Z"
         fill="#FF866E"
       />
       <path
         d="M19.8813 17.1867C19.3115 17.3858 18.6911 17.3858 18.1213 17.1867L5.66797 12.8267V14.8267L18.1213 19.1867C18.6911 19.3858 19.3115 19.3858 19.8813 19.1867L32.3346 14.8267V12.8267L19.8813 17.1867Z"
         fill="#FFA694"
       />
       <path
         d="M18.1213 17.1867L5.66797 12.8267V17.02C5.66852 17.1578 5.71176 17.2921 5.79175 17.4043C5.87174 17.5165 5.98454 17.6012 6.11464 17.6467L18.1146 21.8533C18.6844 22.0525 19.3049 22.0525 19.8746 21.8533L31.8746 17.6467C32.0047 17.6012 32.1175 17.5165 32.1975 17.4043C32.2775 17.2921 32.3208 17.1578 32.3213 17.02V12.8267L19.8813 17.1867C19.3115 17.3858 18.6911 17.3858 18.1213 17.1867Z"
         stroke="#45413C"
         stroke-width="0.666667"
         stroke-linecap="round"
         stroke-linejoin="round"
       />
       <path
         d="M5.66797 12.8266L18.1213 8.46664C18.6911 8.26747 19.3115 8.26747 19.8813 8.46664L32.3346 12.8266L19.8813 17.1866C19.3115 17.3858 18.6911 17.3858 18.1213 17.1866L5.66797 12.8266Z"
         fill="#FF866E"
         stroke="#45413C"
         stroke-width="0.666667"
         stroke-linecap="round"
         stroke-linejoin="round"
       />
       <path
         d="M21.772 9.1333L8.33203 13.76V18.4266L14.332 20.5266V15.86L27.772 11.2333L21.772 9.1333Z"
         fill="#EDDBFF"
         stroke="#45413C"
         stroke-width="0.666667"
         stroke-linecap="round"
         stroke-linejoin="round"
       />
       <path
         d="M10.1133 14.3867L13.1466 15.4467"
         stroke="#BF8DF2"
         stroke-width="0.666667"
         stroke-linecap="round"
         stroke-linejoin="round"
       />
       <path
         d="M9 18.66V30.3267L15 32.4267V20.76L9 18.66Z"
         fill="#EDDBFF"
       />
       <path
         d="M9 18.66V21.9934L15 24.0934V20.76L9 18.66Z"
         fill="#DABFF5"
       />
       <path
         d="M9 18.66V30.3267L15 32.4267V20.76L9 18.66Z"
         stroke="#45413C"
         stroke-width="0.666667"
         stroke-linecap="round"
         stroke-linejoin="round"
       />
       <path
         d="M16.2266 9.1333L29.6666 13.76V18.4266L23.6666 20.5266V15.86L10.2266 11.2333L16.2266 9.1333Z"
         fill="#EDDBFF"
         stroke="#45413C"
         stroke-width="0.666667"
         stroke-linecap="round"
         stroke-linejoin="round"
       />
       <path
         d="M27.8849 14.3867L24.8516 15.4467"
         stroke="#BF8DF2"
         stroke-width="0.666667"
         stroke-linecap="round"
         stroke-linejoin="round"
       />
       <path
         d="M29 18.66V30.3267L23 32.4267V20.76L29 18.66Z"
         fill="#EDDBFF"
       />
       <path
         d="M29 18.66V21.9934L23 24.0934V20.76L29 18.66Z"
         fill="#DABFF5"
       />
       <path
         d="M29 18.66V30.3267L23 32.4267V20.76L29 18.66Z"
         stroke="#45413C"
         stroke-width="0.666667"
         stroke-linecap="round"
         stroke-linejoin="round"
       />
       <path
         d="M17.0008 13.5266L18.0008 11.86C18.0008 11.86 13.8742 6.4733 9.33417 7.78663C8.89832 7.91288 8.51837 8.18358 8.25669 8.55429C7.99501 8.925 7.86718 9.37367 7.89417 9.82663L8.0275 12L17.0008 13.5266Z"
         fill="#DABFF5"
         stroke="#45413C"
         stroke-width="0.666667"
         stroke-linecap="round"
         stroke-linejoin="round"
       />
       <path
         d="M16.9995 13.5266C16.9995 13.5266 13.2795 15.0533 8.39946 12.58C8.27595 12.5221 8.17316 12.4277 8.10496 12.3096C8.03676 12.1915 8.00643 12.0553 8.01805 11.9194C8.02968 11.7835 8.08271 11.6545 8.16998 11.5497C8.25726 11.4448 8.37458 11.3693 8.50613 11.3333C9.98777 10.8958 11.5604 10.8688 13.0562 11.2551C14.552 11.6413 15.9149 12.4264 16.9995 13.5266Z"
         fill="#BF8DF2"
         stroke="#45413C"
         stroke-width="0.666667"
         stroke-linecap="round"
         stroke-linejoin="round"
       />
       <path
         d="M21.0352 13.5266L20.0352 11.86C20.0352 11.86 24.1618 6.4733 28.7018 7.78663C29.1327 7.91784 29.5067 8.19066 29.7632 8.5609C30.0197 8.93114 30.1437 9.37712 30.1152 9.82663L29.9752 12L21.0352 13.5266Z"
         fill="#DABFF5"
         stroke="#45413C"
         stroke-width="0.666667"
         stroke-linecap="round"
         stroke-linejoin="round"
       />
       <path
         d="M21.0352 13.5267C21.0352 13.5267 24.7218 15.0534 29.6018 12.5801C29.7253 12.5222 29.8281 12.4278 29.8963 12.3097C29.9645 12.1916 29.9949 12.0554 29.9832 11.9195C29.9716 11.7836 29.9186 11.6546 29.8313 11.5498C29.744 11.445 29.6267 11.3694 29.4952 11.3334C28.0183 10.9024 26.4523 10.8787 24.9631 11.2648C23.4738 11.6509 22.1166 12.4324 21.0352 13.5267Z"
         fill="#BF8DF2"
         stroke="#45413C"
         stroke-width="0.666667"
         stroke-linecap="round"
         stroke-linejoin="round"
       />
       <path
         d="M20.5878 12.9399C20.5878 12.9399 25.4411 14.4333 26.4945 18.0066L24.1011 17.5933L23.3545 19.9999C23.3545 19.9999 21.0945 14.5599 19.0011 13.7799L20.5878 12.9399ZM17.4145 12.9399C17.4145 12.9399 12.5611 14.4333 11.5078 18.0066L13.9011 17.5933L14.6478 19.9999C14.6478 19.9999 16.9078 14.5399 19.0011 13.7599L17.4145 12.9399Z"
         fill="#BF8DF2"
         stroke="#45413C"
         stroke-width="0.666667"
         stroke-linecap="round"
         stroke-linejoin="round"
       />
       <path
         d="M16 12.1134C16 12.7322 16.3161 13.3257 16.8787 13.7633C17.4413 14.2009 18.2044 14.4467 19 14.4467C19.7956 14.4467 20.5587 14.2009 21.1213 13.7633C21.6839 13.3257 22 12.7322 22 12.1134C22 11.4945 21.6839 10.901 21.1213 10.4634C20.5587 10.0259 19.7956 9.78003 19 9.78003C18.2044 9.78003 17.4413 10.0259 16.8787 10.4634C16.3161 10.901 16 11.4945 16 12.1134Z"
         fill="#BF8DF2"
       />
       <path
         d="M19 11.1134C19.5881 11.0773 20.1736 11.2164 20.6827 11.5131C21.1917 11.8097 21.6014 12.2506 21.86 12.78C21.9466 12.5681 21.994 12.3422 22 12.1134C22 10.82 20.6667 9.78003 19 9.78003C17.3333 9.78003 16 10.82 16 12.1134C16.006 12.3422 16.0534 12.5681 16.14 12.78C16.3986 12.2506 16.8083 11.8097 17.3173 11.5131C17.8264 11.2164 18.4119 11.0773 19 11.1134Z"
         fill="#DABFF5"
       />
       <path
         d="M16 12.1134C16 12.7322 16.3161 13.3257 16.8787 13.7633C17.4413 14.2009 18.2044 14.4467 19 14.4467C19.7956 14.4467 20.5587 14.2009 21.1213 13.7633C21.6839 13.3257 22 12.7322 22 12.1134C22 11.4945 21.6839 10.901 21.1213 10.4634C20.5587 10.0259 19.7956 9.78003 19 9.78003C18.2044 9.78003 17.4413 10.0259 16.8787 10.4634C16.3161 10.901 16 11.4945 16 12.1134Z"
         stroke="#45413C"
         stroke-width="0.666667"
         stroke-linecap="round"
         stroke-linejoin="round"
       />
       <path
         opacity="0.15"
         d="M30.5781 31.0719C30.5781 31.1641 31.0056 31.2526 31.7665 31.3178C32.5274 31.383 33.5593 31.4197 34.6354 31.4197C35.7114 31.4197 36.7434 31.383 37.5043 31.3178C38.2652 31.2526 38.6926 31.1641 38.6926 31.0719C38.6926 30.9797 38.2652 30.8912 37.5043 30.826C36.7434 30.7608 35.7114 30.7241 34.6354 30.7241C33.5593 30.7241 32.5274 30.7608 31.7665 30.826C31.0056 30.8912 30.5781 30.9797 30.5781 31.0719Z"
         fill="#45413C"
       />
       <path
         d="M34.3295 26.9637L30.2305 25.5286V29.4212C30.2307 29.4691 30.2457 29.5158 30.2735 29.5549C30.3013 29.5939 30.3406 29.6233 30.3858 29.6392L34.3271 31.0302C34.5256 31.0975 34.7407 31.0975 34.9392 31.0302L38.8806 29.6392C38.9258 29.6233 38.965 29.5939 38.9928 29.5549C39.0207 29.5158 39.0357 29.4691 39.0359 29.4212V25.5286L34.9415 26.9637C34.7434 27.0329 34.5276 27.0329 34.3295 26.9637Z"
         fill="#FF866E"
       />
       <path
         d="M34.9415 26.9637C34.7434 27.0329 34.5276 27.0329 34.3295 26.9637L30.2305 25.5286V26.6878L34.3295 28.1229C34.5276 28.1922 34.7434 28.1922 34.9415 28.1229L39.0405 26.6878V25.5286L34.9415 26.9637Z"
         fill="#FF6242"
       />
       <path
         d="M34.3295 26.9637L30.2305 25.5286V29.4212C30.2307 29.4691 30.2457 29.5158 30.2735 29.5549C30.3013 29.5939 30.3406 29.6233 30.3858 29.6392L34.3271 31.0302C34.5256 31.0975 34.7407 31.0975 34.9392 31.0302L38.8806 29.6392C38.9258 29.6233 38.965 29.5939 38.9928 29.5549C39.0207 29.5158 39.0357 29.4691 39.0359 29.4212V25.5286L34.9415 26.9637C34.7434 27.0329 34.5276 27.0329 34.3295 26.9637Z"
         stroke="#45413C"
         stroke-width="0.3"
         stroke-linecap="round"
         stroke-linejoin="round"
       />
       <path
         d="M34.6367 30.6638V27.5339"
         stroke="#E04122"
         stroke-width="0.3"
         stroke-linecap="round"
         stroke-linejoin="round"
       />
       <path
         d="M34.3308 25.3407L30 23.8245V25.2828C30.0002 25.3307 30.0152 25.3774 30.043 25.4164C30.0709 25.4554 30.1101 25.4849 30.1553 25.5007L34.3285 26.9636C34.5267 27.0329 34.7424 27.0329 34.9406 26.9636L39.1138 25.5007C39.159 25.4849 39.1982 25.4554 39.2261 25.4164C39.2539 25.3774 39.2689 25.3307 39.2691 25.2828V23.8245L34.9429 25.3407C34.7448 25.41 34.529 25.41 34.3308 25.3407Z"
         fill="#FF866E"
       />
       <path
         d="M34.9429 25.3407C34.7448 25.41 34.529 25.41 34.3308 25.3407L30 23.8245V24.52L34.3308 26.0363C34.529 26.1055 34.7448 26.1055 34.9429 26.0363L39.2737 24.52V23.8245L34.9429 25.3407Z"
         fill="#FFA694"
       />
       <path
         d="M34.3308 25.3407L30 23.8245V25.2828C30.0002 25.3307 30.0152 25.3774 30.043 25.4164C30.0709 25.4554 30.1101 25.4849 30.1553 25.5007L34.3285 26.9636C34.5267 27.0329 34.7424 27.0329 34.9406 26.9636L39.1138 25.5007C39.159 25.4849 39.1982 25.4554 39.2261 25.4164C39.2539 25.3774 39.2689 25.3307 39.2691 25.2828V23.8245L34.9429 25.3407C34.7448 25.41 34.529 25.41 34.3308 25.3407Z"
         stroke="#45413C"
         stroke-width="0.3"
         stroke-linecap="round"
         stroke-linejoin="round"
       />
       <path
         d="M30 23.8244L34.3308 22.3082C34.529 22.2389 34.7448 22.2389 34.9429 22.3082L39.2737 23.8244L34.9429 25.3407C34.7448 25.41 34.529 25.41 34.3308 25.3407L30 23.8244Z"
         fill="#FF866E"
         stroke="#45413C"
         stroke-width="0.3"
         stroke-linecap="round"
         stroke-linejoin="round"
       />
       <path
         d="M35.5997 22.54L30.9258 24.149V25.7719L33.0124 26.5022V24.8793L37.6863 23.2703L35.5997 22.54Z"
         fill="#EDDBFF"
         stroke="#45413C"
         stroke-width="0.3"
         stroke-linecap="round"
         stroke-linejoin="round"
       />
       <path
         d="M31.5469 24.3671L32.6018 24.7357"
         stroke="#BF8DF2"
         stroke-width="0.3"
         stroke-linecap="round"
         stroke-linejoin="round"
       />
       <path
         d="M31.1602 25.8531V29.9104L33.2467 30.6407V26.5835L31.1602 25.8531Z"
         fill="#EDDBFF"
       />
       <path
         d="M31.1602 25.8531V27.0124L33.2467 27.7427V26.5835L31.1602 25.8531Z"
         fill="#DABFF5"
       />
       <path
         d="M31.1602 25.8531V29.9104L33.2467 30.6407V26.5835L31.1602 25.8531Z"
         stroke="#45413C"
         stroke-width="0.3"
         stroke-linecap="round"
         stroke-linejoin="round"
       />
       <path
         d="M33.6725 22.54L38.3465 24.149V25.7719L36.2599 26.5022V24.8793L31.5859 23.2703L33.6725 22.54Z"
         fill="#EDDBFF"
         stroke="#45413C"
         stroke-width="0.3"
         stroke-linecap="round"
         stroke-linejoin="round"
       />
       <path
         d="M37.7268 24.3671L36.6719 24.7357"
         stroke="#BF8DF2"
         stroke-width="0.3"
         stroke-linecap="round"
         stroke-linejoin="round"
       />
       <path
         d="M38.1139 25.8531V29.9104L36.0273 30.6407V26.5835L38.1139 25.8531Z"
         fill="#EDDBFF"
       />
       <path
         d="M38.1139 25.8531V27.0124L36.0273 27.7427V26.5835L38.1139 25.8531Z"
         fill="#DABFF5"
       />
       <path
         d="M38.1139 25.8531V29.9104L36.0273 30.6407V26.5835L38.1139 25.8531Z"
         stroke="#45413C"
         stroke-width="0.3"
         stroke-linecap="round"
         stroke-linejoin="round"
       />
       <path
         d="M33.9417 24.0679L34.2894 23.4883C34.2894 23.4883 32.8543 21.615 31.2755 22.0717C31.1239 22.1157 30.9917 22.2098 30.9007 22.3387C30.8097 22.4676 30.7653 22.6237 30.7747 22.7812L30.821 23.537L33.9417 24.0679Z"
         fill="#DABFF5"
         stroke="#45413C"
         stroke-width="0.3"
         stroke-linecap="round"
         stroke-linejoin="round"
       />
       <path
         d="M33.9407 24.0679C33.9407 24.0679 32.647 24.5989 30.9499 23.7387C30.9069 23.7186 30.8712 23.6858 30.8475 23.6447C30.8238 23.6036 30.8132 23.5563 30.8173 23.509C30.8213 23.4618 30.8397 23.4169 30.8701 23.3804C30.9004 23.344 30.9412 23.3177 30.987 23.3052C31.5023 23.153 32.0492 23.1436 32.5693 23.278C33.0895 23.4123 33.5635 23.6853 33.9407 24.0679Z"
         fill="#BF8DF2"
         stroke="#45413C"
         stroke-width="0.3"
         stroke-linecap="round"
         stroke-linejoin="round"
       />
       <path
         d="M35.3439 24.0679L34.9961 23.4883C34.9961 23.4883 36.4312 21.615 38.0101 22.0717C38.1599 22.1174 38.29 22.2123 38.3792 22.341C38.4684 22.4698 38.5115 22.6249 38.5016 22.7812L38.4529 23.537L35.3439 24.0679Z"
         fill="#DABFF5"
         stroke="#45413C"
         stroke-width="0.3"
         stroke-linecap="round"
         stroke-linejoin="round"
       />
       <path
         d="M35.3438 24.068C35.3438 24.068 36.6258 24.5989 38.3229 23.7388C38.3659 23.7187 38.4016 23.6858 38.4254 23.6448C38.4491 23.6037 38.4596 23.5563 38.4556 23.5091C38.4515 23.4618 38.4331 23.4169 38.4027 23.3805C38.3724 23.344 38.3316 23.3178 38.2858 23.3052C37.7722 23.1553 37.2277 23.1471 36.7097 23.2814C36.1918 23.4156 35.7198 23.6874 35.3438 24.068Z"
         fill="#BF8DF2"
         stroke="#45413C"
         stroke-width="0.3"
         stroke-linecap="round"
         stroke-linejoin="round"
       />
       <path
         d="M35.189 23.8639C35.189 23.8639 36.8768 24.3832 37.2431 25.6259L36.4108 25.4822L36.1511 26.3191C36.1511 26.3191 35.3652 24.4273 34.6372 24.156L35.189 23.8639ZM34.0854 23.8639C34.0854 23.8639 32.3976 24.3832 32.0312 25.6259L32.8636 25.4822L33.1232 26.3191C33.1232 26.3191 33.9092 24.4203 34.6372 24.1491L34.0854 23.8639Z"
         fill="#BF8DF2"
         stroke="#45413C"
         stroke-width="0.3"
         stroke-linecap="round"
         stroke-linejoin="round"
       />
       <path
         d="M33.5938 23.5765C33.5938 23.7917 33.7037 23.9981 33.8993 24.1503C34.095 24.3024 34.3603 24.3879 34.637 24.3879C34.9137 24.3879 35.1791 24.3024 35.3748 24.1503C35.5704 23.9981 35.6803 23.7917 35.6803 23.5765C35.6803 23.3613 35.5704 23.1549 35.3748 23.0027C35.1791 22.8505 34.9137 22.765 34.637 22.765C34.3603 22.765 34.095 22.8505 33.8993 23.0027C33.7037 23.1549 33.5938 23.3613 33.5938 23.5765Z"
         fill="#BF8DF2"
       />
       <path
         d="M34.637 23.2287C34.8416 23.2162 35.0452 23.2645 35.2222 23.3677C35.3993 23.4709 35.5417 23.6242 35.6317 23.8083C35.6618 23.7346 35.6783 23.6561 35.6803 23.5765C35.6803 23.1267 35.2167 22.765 34.637 22.765C34.0574 22.765 33.5938 23.1267 33.5938 23.5765C33.5958 23.6561 33.6123 23.7346 33.6424 23.8083C33.7324 23.6242 33.8748 23.4709 34.0519 23.3677C34.2289 23.2645 34.4325 23.2162 34.637 23.2287Z"
         fill="#DABFF5"
       />
       <path
         d="M33.5938 23.5765C33.5938 23.7917 33.7037 23.9981 33.8993 24.1503C34.095 24.3024 34.3603 24.3879 34.637 24.3879C34.9137 24.3879 35.1791 24.3024 35.3748 24.1503C35.5704 23.9981 35.6803 23.7917 35.6803 23.5765C35.6803 23.3613 35.5704 23.1549 35.3748 23.0027C35.1791 22.8505 34.9137 22.765 34.637 22.765C34.3603 22.765 34.095 22.8505 33.8993 23.0027C33.7037 23.1549 33.5938 23.3613 33.5938 23.5765Z"
         stroke="#45413C"
         stroke-width="0.3"
         stroke-linecap="round"
         stroke-linejoin="round"
       />
       <path
         opacity="0.15"
         d="M3.57812 35.0719C3.57813 35.1641 4.00559 35.2526 4.76647 35.3178C5.52735 35.383 6.55933 35.4197 7.63539 35.4197C8.71144 35.4197 9.74342 35.383 10.5043 35.3178C11.2652 35.2526 11.6926 35.1641 11.6926 35.0719C11.6926 34.9797 11.2652 34.8912 10.5043 34.826C9.74342 34.7608 8.71144 34.7241 7.63539 34.7241C6.55933 34.7241 5.52735 34.7608 4.76647 34.826C4.00559 34.8912 3.57813 34.9797 3.57812 35.0719Z"
         fill="#45413C"
       />
       <path
         d="M7.32946 30.9637L3.23047 29.5286V33.4212C3.23066 33.4691 3.2457 33.5158 3.27352 33.5549C3.30133 33.5939 3.34056 33.6233 3.3858 33.6392L7.32714 35.0302C7.52562 35.0975 7.74074 35.0975 7.93921 35.0302L11.8806 33.6392C11.9258 33.6233 11.965 33.5939 11.9928 33.5549C12.0207 33.5158 12.0357 33.4691 12.0359 33.4212V29.5286L7.94153 30.9637C7.74339 31.0329 7.52761 31.0329 7.32946 30.9637Z"
         fill="#FF866E"
       />
       <path
         d="M7.94153 30.9637C7.74339 31.0329 7.52761 31.0329 7.32946 30.9637L3.23047 29.5286V30.6878L7.32946 32.1229C7.52761 32.1922 7.74339 32.1922 7.94153 32.1229L12.0405 30.6878V29.5286L7.94153 30.9637Z"
         fill="#FF6242"
       />
       <path
         d="M7.32946 30.9637L3.23047 29.5286V33.4212C3.23066 33.4691 3.2457 33.5158 3.27352 33.5549C3.30133 33.5939 3.34056 33.6233 3.3858 33.6392L7.32714 35.0302C7.52562 35.0975 7.74074 35.0975 7.93921 35.0302L11.8806 33.6392C11.9258 33.6233 11.965 33.5939 11.9928 33.5549C12.0207 33.5158 12.0357 33.4691 12.0359 33.4212V29.5286L7.94153 30.9637C7.74339 31.0329 7.52761 31.0329 7.32946 30.9637Z"
         stroke="#45413C"
         stroke-width="0.3"
         stroke-linecap="round"
         stroke-linejoin="round"
       />
       <path
         d="M7.63672 34.6638V31.5339"
         stroke="#E04122"
         stroke-width="0.3"
         stroke-linecap="round"
         stroke-linejoin="round"
       />
       <path
         d="M7.33084 29.3407L3 27.8245V29.2828C3.00019 29.3307 3.01523 29.3774 3.04305 29.4164C3.07086 29.4554 3.11009 29.4849 3.15534 29.5007L7.32852 30.9636C7.52666 31.0329 7.74244 31.0329 7.94059 30.9636L12.1138 29.5007C12.159 29.4849 12.1982 29.4554 12.2261 29.4164C12.2539 29.3774 12.2689 29.3307 12.2691 29.2828V27.8245L7.9429 29.3407C7.74476 29.41 7.52898 29.41 7.33084 29.3407Z"
         fill="#FF866E"
       />
       <path
         d="M7.9429 29.3407C7.74476 29.41 7.52898 29.41 7.33084 29.3407L3 27.8245V28.52L7.33084 30.0363C7.52898 30.1055 7.74476 30.1055 7.9429 30.0363L12.2737 28.52V27.8245L7.9429 29.3407Z"
         fill="#FFA694"
       />
       <path
         d="M7.33084 29.3407L3 27.8245V29.2828C3.00019 29.3307 3.01523 29.3774 3.04305 29.4164C3.07086 29.4554 3.11009 29.4849 3.15534 29.5007L7.32852 30.9636C7.52666 31.0329 7.74244 31.0329 7.94059 30.9636L12.1138 29.5007C12.159 29.4849 12.1982 29.4554 12.2261 29.4164C12.2539 29.3774 12.2689 29.3307 12.2691 29.2828V27.8245L7.9429 29.3407C7.74476 29.41 7.52898 29.41 7.33084 29.3407Z"
         stroke="#45413C"
         stroke-width="0.3"
         stroke-linecap="round"
         stroke-linejoin="round"
       />
       <path
         d="M3 27.8244L7.33084 26.3082C7.52898 26.2389 7.74476 26.2389 7.9429 26.3082L12.2737 27.8244L7.9429 29.3407C7.74476 29.41 7.52898 29.41 7.33084 29.3407L3 27.8244Z"
         fill="#FF866E"
         stroke="#45413C"
         stroke-width="0.3"
         stroke-linecap="round"
         stroke-linejoin="round"
       />
       <path
         d="M8.59975 26.54L3.92578 28.149V29.7719L6.01237 30.5022V28.8793L10.6863 27.2703L8.59975 26.54Z"
         fill="#EDDBFF"
         stroke="#45413C"
         stroke-width="0.3"
         stroke-linecap="round"
         stroke-linejoin="round"
       />
       <path
         d="M4.54688 28.3671L5.60176 28.7357"
         stroke="#BF8DF2"
         stroke-width="0.3"
         stroke-linecap="round"
         stroke-linejoin="round"
       />
       <path
         d="M4.16016 29.8531V33.9104L6.24675 34.6407V30.5835L4.16016 29.8531Z"
         fill="#EDDBFF"
       />
       <path
         d="M4.16016 29.8531V31.0124L6.24675 31.7427V30.5835L4.16016 29.8531Z"
         fill="#DABFF5"
       />
       <path
         d="M4.16016 29.8531V33.9104L6.24675 34.6407V30.5835L4.16016 29.8531Z"
         stroke="#45413C"
         stroke-width="0.3"
         stroke-linecap="round"
         stroke-linejoin="round"
       />
       <path
         d="M6.67253 26.54L11.3465 28.149V29.7719L9.2599 30.5022V28.8793L4.58594 27.2703L6.67253 26.54Z"
         fill="#EDDBFF"
         stroke="#45413C"
         stroke-width="0.3"
         stroke-linecap="round"
         stroke-linejoin="round"
       />
       <path
         d="M10.7268 28.3671L9.67188 28.7357"
         stroke="#BF8DF2"
         stroke-width="0.3"
         stroke-linecap="round"
         stroke-linejoin="round"
       />
       <path
         d="M11.1139 29.8531V33.9104L9.02734 34.6407V30.5835L11.1139 29.8531Z"
         fill="#EDDBFF"
       />
       <path
         d="M11.1139 29.8531V31.0124L9.02734 31.7427V30.5835L11.1139 29.8531Z"
         fill="#DABFF5"
       />
       <path
         d="M11.1139 29.8531V33.9104L9.02734 34.6407V30.5835L11.1139 29.8531Z"
         stroke="#45413C"
         stroke-width="0.3"
         stroke-linecap="round"
         stroke-linejoin="round"
       />
       <path
         d="M6.94165 28.0679L7.28942 27.4883C7.28942 27.4883 5.85431 25.615 4.27545 26.0717C4.12388 26.1157 3.99174 26.2098 3.90074 26.3387C3.80974 26.4676 3.76528 26.6237 3.77467 26.7812L3.82104 27.537L6.94165 28.0679Z"
         fill="#DABFF5"
         stroke="#45413C"
         stroke-width="0.3"
         stroke-linecap="round"
         stroke-linejoin="round"
       />
       <path
         d="M6.94067 28.0679C6.94067 28.0679 5.64699 28.5989 3.94989 27.7387C3.90694 27.7186 3.87119 27.6858 3.84747 27.6447C3.82376 27.6036 3.81321 27.5563 3.81725 27.509C3.82129 27.4618 3.83974 27.4169 3.87009 27.3804C3.90044 27.344 3.94124 27.3177 3.98699 27.3052C4.50225 27.153 5.04915 27.1436 5.56934 27.278C6.08953 27.4123 6.5635 27.6853 6.94067 28.0679Z"
         fill="#BF8DF2"
         stroke="#45413C"
         stroke-width="0.3"
         stroke-linecap="round"
         stroke-linejoin="round"
       />
       <path
         d="M8.34386 28.0679L7.99609 27.4883C7.99609 27.4883 9.43121 25.615 11.0101 26.0717C11.1599 26.1174 11.29 26.2123 11.3792 26.341C11.4684 26.4698 11.5115 26.6249 11.5016 26.7812L11.4529 27.537L8.34386 28.0679Z"
         fill="#DABFF5"
         stroke="#45413C"
         stroke-width="0.3"
         stroke-linecap="round"
         stroke-linejoin="round"
       />
       <path
         d="M8.34375 28.068C8.34375 28.068 9.62585 28.5989 11.3229 27.7388C11.3659 27.7187 11.4016 27.6858 11.4254 27.6448C11.4491 27.6037 11.4596 27.5563 11.4556 27.5091C11.4515 27.4618 11.4331 27.4169 11.4027 27.3805C11.3724 27.344 11.3316 27.3178 11.2858 27.3052C10.7722 27.1553 10.2277 27.1471 9.70974 27.2814C9.19182 27.4156 8.71984 27.6874 8.34375 28.068Z"
         fill="#BF8DF2"
         stroke="#45413C"
         stroke-width="0.3"
         stroke-linecap="round"
         stroke-linejoin="round"
       />
       <path
         d="M8.18896 27.8639C8.18896 27.8639 9.87678 28.3832 10.2431 29.6259L9.41077 29.4822L9.15111 30.3191C9.15111 30.3191 8.36516 28.4273 7.63717 28.156L8.18896 27.8639ZM7.08538 27.8639C7.08538 27.8639 5.39756 28.3832 5.03125 29.6259L5.86357 29.4822L6.12323 30.3191C6.12323 30.3191 6.90918 28.4203 7.63717 28.1491L7.08538 27.8639Z"
         fill="#BF8DF2"
         stroke="#45413C"
         stroke-width="0.3"
         stroke-linecap="round"
         stroke-linejoin="round"
       />
       <path
         d="M6.59375 27.5765C6.59375 27.7917 6.70367 27.9981 6.89932 28.1503C7.09498 28.3024 7.36035 28.3879 7.63705 28.3879C7.91375 28.3879 8.17911 28.3024 8.37477 28.1503C8.57042 27.9981 8.68034 27.7917 8.68034 27.5765C8.68034 27.3613 8.57042 27.1549 8.37477 27.0027C8.17911 26.8505 7.91375 26.765 7.63705 26.765C7.36035 26.765 7.09498 26.8505 6.89932 27.0027C6.70367 27.1549 6.59375 27.3613 6.59375 27.5765Z"
         fill="#BF8DF2"
       />
       <path
         d="M7.63705 27.2287C7.84156 27.2162 8.0452 27.2645 8.22223 27.3677C8.39926 27.4709 8.54174 27.6242 8.63165 27.8083C8.66177 27.7346 8.67826 27.6561 8.68034 27.5765C8.68034 27.1267 8.21665 26.765 7.63705 26.765C7.05744 26.765 6.59375 27.1267 6.59375 27.5765C6.59583 27.6561 6.61232 27.7346 6.64244 27.8083C6.73235 27.6242 6.87483 27.4709 7.05186 27.3677C7.22889 27.2645 7.43253 27.2162 7.63705 27.2287Z"
         fill="#DABFF5"
       />
       <path
         d="M6.59375 27.5765C6.59375 27.7917 6.70367 27.9981 6.89932 28.1503C7.09498 28.3024 7.36035 28.3879 7.63705 28.3879C7.91375 28.3879 8.17911 28.3024 8.37477 28.1503C8.57042 27.9981 8.68034 27.7917 8.68034 27.5765C8.68034 27.3613 8.57042 27.1549 8.37477 27.0027C8.17911 26.8505 7.91375 26.765 7.63705 26.765C7.36035 26.765 7.09498 26.8505 6.89932 27.0027C6.70367 27.1549 6.59375 27.3613 6.59375 27.5765Z"
         stroke="#45413C"
         stroke-width="0.3"
         stroke-linecap="round"
         stroke-linejoin="round"
       />
       <path
         opacity="0.15"
         d="M27.3906 33.1372C27.3906 33.1996 27.6798 33.2595 28.1945 33.3036C28.7093 33.3477 29.4074 33.3725 30.1354 33.3725C30.8633 33.3725 31.5615 33.3477 32.0762 33.3036C32.591 33.2595 32.8802 33.1996 32.8802 33.1372C32.8802 33.0748 32.591 33.015 32.0762 32.9709C31.5615 32.9268 30.8633 32.902 30.1354 32.902C29.4074 32.902 28.7093 32.9268 28.1945 32.9709C27.6798 33.015 27.3906 33.0748 27.3906 33.1372Z"
         fill="#45413C"
       />
       <path
         d="M29.9292 30.3579L27.1562 29.3871V32.0205C27.1564 32.0529 27.1666 32.0845 27.1854 32.1109C27.2042 32.1373 27.2307 32.1572 27.2613 32.1679L29.9277 33.109C30.0619 33.1545 30.2075 33.1545 30.3417 33.109L33.0081 32.1679C33.0387 32.1572 33.0652 32.1373 33.084 32.1109C33.1029 32.0845 33.113 32.0529 33.1132 32.0205V29.3871L30.3433 30.3579C30.2093 30.4048 30.0633 30.4048 29.9292 30.3579Z"
         fill="#FF866E"
       />
       <path
         d="M30.3433 30.3579C30.2093 30.4048 30.0633 30.4048 29.9292 30.3579L27.1562 29.3871V30.1713L29.9292 31.1422C30.0633 31.189 30.2093 31.189 30.3433 31.1422L33.1163 30.1713V29.3871L30.3433 30.3579Z"
         fill="#FF6242"
       />
       <path
         d="M29.9292 30.3579L27.1562 29.3871V32.0205C27.1564 32.0529 27.1666 32.0845 27.1854 32.1109C27.2042 32.1373 27.2307 32.1572 27.2613 32.1679L29.9277 33.109C30.0619 33.1545 30.2075 33.1545 30.3417 33.109L33.0081 32.1679C33.0387 32.1572 33.0652 32.1373 33.084 32.1109C33.1029 32.0845 33.113 32.0529 33.1132 32.0205V29.3871L30.3433 30.3579C30.2093 30.4048 30.0633 30.4048 29.9292 30.3579Z"
         stroke="#45413C"
         stroke-width="0.3"
         stroke-linecap="round"
         stroke-linejoin="round"
       />
       <path
         d="M30.1367 32.8612V30.7438"
         stroke="#E04122"
         stroke-width="0.3"
         stroke-linecap="round"
         stroke-linejoin="round"
       />
       <path
         d="M29.9298 29.26L27 28.2343V29.2208C27.0001 29.2532 27.0103 29.2848 27.0291 29.3112C27.0479 29.3376 27.0745 29.3575 27.1051 29.3682L29.9283 30.3579C30.0623 30.4048 30.2083 30.4048 30.3423 30.3579L33.1655 29.3682C33.1961 29.3575 33.2227 29.3376 33.2415 29.3112C33.2603 29.2848 33.2705 29.2532 33.2706 29.2208V28.2343L30.3439 29.26C30.2099 29.3069 30.0639 29.3069 29.9298 29.26Z"
         fill="#FF866E"
       />
       <path
         d="M30.3439 29.26C30.2099 29.3069 30.0639 29.3069 29.9298 29.26L27 28.2343V28.7048L29.9298 29.7305C30.0639 29.7774 30.2099 29.7774 30.3439 29.7305L33.2737 28.7048V28.2343L30.3439 29.26Z"
         fill="#FFA694"
       />
       <path
         d="M29.9298 29.26L27 28.2343V29.2208C27.0001 29.2532 27.0103 29.2848 27.0291 29.3112C27.0479 29.3376 27.0745 29.3575 27.1051 29.3682L29.9283 30.3579C30.0623 30.4048 30.2083 30.4048 30.3423 30.3579L33.1655 29.3682C33.1961 29.3575 33.2227 29.3376 33.2415 29.3112C33.2603 29.2848 33.2705 29.2532 33.2706 29.2208V28.2343L30.3439 29.26C30.2099 29.3069 30.0639 29.3069 29.9298 29.26Z"
         stroke="#45413C"
         stroke-width="0.3"
         stroke-linecap="round"
         stroke-linejoin="round"
       />
       <path
         d="M27 28.2342L29.9298 27.2085C30.0639 27.1616 30.2099 27.1616 30.3439 27.2085L33.2737 28.2342L30.3439 29.26C30.2099 29.3069 30.0639 29.3069 29.9298 29.26L27 28.2342Z"
         fill="#FF866E"
         stroke="#45413C"
         stroke-width="0.3"
         stroke-linecap="round"
         stroke-linejoin="round"
       />
       <path
         d="M30.787 27.3654L27.625 28.4539V29.5518L29.0366 30.0458V28.9479L32.1986 27.8594L30.787 27.3654Z"
         fill="#EDDBFF"
         stroke="#45413C"
         stroke-width="0.3"
         stroke-linecap="round"
         stroke-linejoin="round"
       />
       <path
         d="M28.0469 28.6013L28.7605 28.8507"
         stroke="#BF8DF2"
         stroke-width="0.3"
         stroke-linecap="round"
         stroke-linejoin="round"
       />
       <path
         d="M27.7852 29.6067V32.3515L29.1967 32.8455V30.1007L27.7852 29.6067Z"
         fill="#EDDBFF"
       />
       <path
         d="M27.7852 29.6067V30.3909L29.1967 30.885V30.1007L27.7852 29.6067Z"
         fill="#DABFF5"
       />
       <path
         d="M27.7852 29.6067V32.3515L29.1967 32.8455V30.1007L27.7852 29.6067Z"
         stroke="#45413C"
         stroke-width="0.3"
         stroke-linecap="round"
         stroke-linejoin="round"
       />
       <path
         d="M29.4858 27.3654L32.6478 28.4539V29.5518L31.2362 30.0458V28.9479L28.0742 27.8594L29.4858 27.3654Z"
         fill="#EDDBFF"
         stroke="#45413C"
         stroke-width="0.3"
         stroke-linecap="round"
         stroke-linejoin="round"
       />
       <path
         d="M32.2254 28.6013L31.5117 28.8507"
         stroke="#BF8DF2"
         stroke-width="0.3"
         stroke-linecap="round"
         stroke-linejoin="round"
       />
       <path
         d="M32.4897 29.6067V32.3515L31.0781 32.8455V30.1007L32.4897 29.6067Z"
         fill="#EDDBFF"
       />
       <path
         d="M32.4897 29.6067V30.3909L31.0781 30.885V30.1007L32.4897 29.6067Z"
         fill="#DABFF5"
       />
       <path
         d="M32.4897 29.6067V32.3515L31.0781 32.8455V30.1007L32.4897 29.6067Z"
         stroke="#45413C"
         stroke-width="0.3"
         stroke-linecap="round"
         stroke-linejoin="round"
       />
       <path
         d="M29.6668 28.399L29.902 28.0069C29.902 28.0069 28.9312 26.7396 27.8631 27.0485C27.7605 27.0782 27.6711 27.1419 27.6096 27.2291C27.548 27.3164 27.5179 27.4219 27.5243 27.5285L27.5556 28.0398L29.6668 28.399Z"
         fill="#DABFF5"
         stroke="#45413C"
         stroke-width="0.3"
         stroke-linecap="round"
         stroke-linejoin="round"
       />
       <path
         d="M29.6644 28.399C29.6644 28.399 28.7892 28.7581 27.6411 28.1763C27.612 28.1626 27.5878 28.1404 27.5718 28.1127C27.5558 28.0849 27.5486 28.0528 27.5514 28.0209C27.5541 27.9889 27.5666 27.9585 27.5871 27.9339C27.6076 27.9092 27.6352 27.8914 27.6662 27.883C28.0148 27.78 28.3847 27.7737 28.7367 27.8646C29.0886 27.9554 29.4092 28.1401 29.6644 28.399Z"
         fill="#BF8DF2"
         stroke="#45413C"
         stroke-width="0.3"
         stroke-linecap="round"
         stroke-linejoin="round"
       />
       <path
         d="M30.6142 28.399L30.3789 28.0069C30.3789 28.0069 31.3498 26.7396 32.4179 27.0485C32.5192 27.0794 32.6072 27.1436 32.6676 27.2307C32.7279 27.3178 32.7571 27.4227 32.7504 27.5285L32.7174 28.0398L30.6142 28.399Z"
         fill="#DABFF5"
         stroke="#45413C"
         stroke-width="0.3"
         stroke-linecap="round"
         stroke-linejoin="round"
       />
       <path
         d="M30.6133 28.399C30.6133 28.399 31.4806 28.7582 32.6287 28.1763C32.6578 28.1627 32.682 28.1405 32.698 28.1127C32.7141 28.0849 32.7212 28.0529 32.7185 28.0209C32.7157 27.9889 32.7032 27.9586 32.6827 27.9339C32.6622 27.9092 32.6346 27.8915 32.6036 27.883C32.2562 27.7816 31.8878 27.776 31.5374 27.8669C31.187 27.9577 30.8677 28.1416 30.6133 28.399Z"
         fill="#BF8DF2"
         stroke="#45413C"
         stroke-width="0.3"
         stroke-linecap="round"
         stroke-linejoin="round"
       />
       <path
         d="M30.5112 28.261C30.5112 28.261 31.653 28.6123 31.9008 29.453L31.3378 29.3558L31.1621 29.922C31.1621 29.922 30.6304 28.6421 30.1379 28.4586L30.5112 28.261ZM29.7646 28.261C29.7646 28.261 28.6228 28.6123 28.375 29.453L28.9381 29.3558L29.1137 29.922C29.1137 29.922 29.6454 28.6374 30.1379 28.4539L29.7646 28.261Z"
         fill="#BF8DF2"
         stroke="#45413C"
         stroke-width="0.3"
         stroke-linecap="round"
         stroke-linejoin="round"
       />
       <path
         d="M29.4297 28.0665C29.4297 28.2121 29.504 28.3518 29.6364 28.4547C29.7688 28.5576 29.9483 28.6155 30.1355 28.6155C30.3227 28.6155 30.5022 28.5576 30.6346 28.4547C30.7669 28.3518 30.8413 28.2121 30.8413 28.0665C30.8413 27.9209 30.7669 27.7813 30.6346 27.6784C30.5022 27.5754 30.3227 27.5176 30.1355 27.5176C29.9483 27.5176 29.7688 27.5754 29.6364 27.6784C29.504 27.7813 29.4297 27.9209 29.4297 28.0665Z"
         fill="#BF8DF2"
       />
       <path
         d="M30.1355 27.8313C30.2738 27.8228 30.4116 27.8555 30.5314 27.9253C30.6511 27.9951 30.7475 28.0988 30.8083 28.2234C30.8287 28.1735 30.8399 28.1204 30.8413 28.0665C30.8413 27.7623 30.5276 27.5176 30.1355 27.5176C29.7434 27.5176 29.4297 27.7623 29.4297 28.0665C29.4311 28.1204 29.4423 28.1735 29.4626 28.2234C29.5235 28.0988 29.6198 27.9951 29.7396 27.9253C29.8594 27.8555 29.9971 27.8228 30.1355 27.8313Z"
         fill="#DABFF5"
       />
       <path
         d="M29.4297 28.0665C29.4297 28.2121 29.504 28.3518 29.6364 28.4547C29.7688 28.5576 29.9483 28.6155 30.1355 28.6155C30.3227 28.6155 30.5022 28.5576 30.6346 28.4547C30.7669 28.3518 30.8413 28.2121 30.8413 28.0665C30.8413 27.9209 30.7669 27.7813 30.6346 27.6784C30.5022 27.5754 30.3227 27.5176 30.1355 27.5176C29.9483 27.5176 29.7688 27.5754 29.6364 27.6784C29.504 27.7813 29.4297 27.9209 29.4297 28.0665Z"
         stroke="#45413C"
         stroke-width="0.3"
         stroke-linecap="round"
         stroke-linejoin="round"
       />
       <path
         opacity="0.15"
         d="M9.375 35.8694C9.375 35.9291 9.65156 35.9863 10.1438 36.0285C10.6361 36.0707 11.3038 36.0944 12 36.0944C12.6962 36.0944 13.3639 36.0707 13.8562 36.0285C14.3484 35.9863 14.625 35.9291 14.625 35.8694C14.625 35.8097 14.3484 35.7525 13.8562 35.7103C13.3639 35.6681 12.6962 35.6444 12 35.6444C11.3038 35.6444 10.6361 35.6681 10.1438 35.7103C9.65156 35.7525 9.375 35.8097 9.375 35.8694Z"
         fill="#45413C"
       />
       <path
         d="M11.8004 33.2115L9.14844 32.283V34.8015C9.14856 34.8325 9.15829 34.8627 9.17629 34.8879C9.19429 34.9132 9.21967 34.9322 9.24894 34.9425L11.7989 35.8425C11.9273 35.886 12.0665 35.886 12.1949 35.8425L14.7449 34.9425C14.7742 34.9322 14.7996 34.9132 14.8176 34.8879C14.8356 34.8627 14.8453 34.8325 14.8454 34.8015V32.283L12.1964 33.2115C12.0682 33.2563 11.9286 33.2563 11.8004 33.2115Z"
         fill="#FF866E"
       />
       <path
         d="M12.1964 33.2115C12.0682 33.2563 11.9286 33.2563 11.8004 33.2115L9.14844 32.283V33.033L11.8004 33.9615C11.9286 34.0063 12.0682 34.0063 12.1964 33.9615L14.8484 33.033V32.283L12.1964 33.2115Z"
         fill="#FF6242"
       />
       <path
         d="M11.8004 33.2115L9.14844 32.283V34.8015C9.14856 34.8325 9.15829 34.8627 9.17629 34.8879C9.19429 34.9132 9.21967 34.9322 9.24894 34.9425L11.7989 35.8425C11.9273 35.886 12.0665 35.886 12.1949 35.8425L14.7449 34.9425C14.7742 34.9322 14.7996 34.9132 14.8176 34.8879C14.8356 34.8627 14.8453 34.8325 14.8454 34.8015V32.283L12.1964 33.2115C12.0682 33.2563 11.9286 33.2563 11.8004 33.2115Z"
         stroke="#45413C"
         stroke-width="0.3"
         stroke-linecap="round"
         stroke-linejoin="round"
       />
       <path
         d="M12 35.6054V33.5804"
         stroke="#E04122"
         stroke-width="0.3"
         stroke-linecap="round"
         stroke-linejoin="round"
       />
       <path
         d="M11.802 32.1614L9 31.1804V32.1239C9.00012 32.1549 9.00985 32.1851 9.02785 32.2104C9.04585 32.2356 9.07123 32.2547 9.1005 32.2649L11.8005 33.2114C11.9287 33.2562 12.0683 33.2562 12.1965 33.2114L14.8965 32.2649C14.9258 32.2547 14.9512 32.2356 14.9691 32.2104C14.9871 32.1851 14.9969 32.1549 14.997 32.1239V31.1804L12.198 32.1614C12.0698 32.2062 11.9302 32.2062 11.802 32.1614Z"
         fill="#FF866E"
       />
       <path
         d="M12.198 32.1614C12.0698 32.2062 11.9302 32.2062 11.802 32.1614L9 31.1804V31.6304L11.802 32.6114C11.9302 32.6562 12.0698 32.6562 12.198 32.6114L15 31.6304V31.1804L12.198 32.1614Z"
         fill="#FFA694"
       />
       <path
         d="M11.802 32.1614L9 31.1804V32.1239C9.00012 32.1549 9.00985 32.1851 9.02785 32.2104C9.04585 32.2356 9.07123 32.2547 9.1005 32.2649L11.8005 33.2114C11.9287 33.2562 12.0683 33.2562 12.1965 33.2114L14.8965 32.2649C14.9258 32.2547 14.9512 32.2356 14.9691 32.2104C14.9871 32.1851 14.9969 32.1549 14.997 32.1239V31.1804L12.198 32.1614C12.0698 32.2062 11.9302 32.2062 11.802 32.1614Z"
         stroke="#45413C"
         stroke-width="0.3"
         stroke-linecap="round"
         stroke-linejoin="round"
       />
       <path
         d="M9 31.1804L11.802 30.1994C11.9302 30.1546 12.0698 30.1546 12.198 30.1994L15 31.1804L12.198 32.1614C12.0698 32.2062 11.9302 32.2062 11.802 32.1614L9 31.1804Z"
         fill="#FF866E"
         stroke="#45413C"
         stroke-width="0.3"
         stroke-linecap="round"
         stroke-linejoin="round"
       />
       <path
         d="M12.6217 30.3494L9.59766 31.3904V32.4404L10.9477 32.9129V31.8629L13.9717 30.8219L12.6217 30.3494Z"
         fill="#EDDBFF"
         stroke="#45413C"
         stroke-width="0.3"
         stroke-linecap="round"
         stroke-linejoin="round"
       />
       <path
         d="M10 31.5315L10.6825 31.77"
         stroke="#BF8DF2"
         stroke-width="0.3"
         stroke-linecap="round"
         stroke-linejoin="round"
       />
       <path
         d="M9.75 32.4929V35.1179L11.1 35.5904V32.9654L9.75 32.4929Z"
         fill="#EDDBFF"
       />
       <path
         d="M9.75 32.4929V33.2429L11.1 33.7154V32.9654L9.75 32.4929Z"
         fill="#DABFF5"
       />
       <path
         d="M9.75 32.4929V35.1179L11.1 35.5904V32.9654L9.75 32.4929Z"
         stroke="#45413C"
         stroke-width="0.3"
         stroke-linecap="round"
         stroke-linejoin="round"
       />
       <path
         d="M11.3773 30.3494L14.4013 31.3904V32.4404L13.0513 32.9129V31.8629L10.0273 30.8219L11.3773 30.3494Z"
         fill="#EDDBFF"
         stroke="#45413C"
         stroke-width="0.3"
         stroke-linecap="round"
         stroke-linejoin="round"
       />
       <path
         d="M13.9989 31.5315L13.3164 31.77"
         stroke="#BF8DF2"
         stroke-width="0.3"
         stroke-linecap="round"
         stroke-linejoin="round"
       />
       <path
         d="M14.2484 32.4929V35.1179L12.8984 35.5904V32.9654L14.2484 32.4929Z"
         fill="#EDDBFF"
       />
       <path
         d="M14.2484 32.4929V33.2429L12.8984 33.7154V32.9654L14.2484 32.4929Z"
         fill="#DABFF5"
       />
       <path
         d="M14.2484 32.4929V35.1179L12.8984 35.5904V32.9654L14.2484 32.4929Z"
         stroke="#45413C"
         stroke-width="0.3"
         stroke-linecap="round"
         stroke-linejoin="round"
       />
       <path
         d="M11.5498 31.3379L11.7748 30.9629C11.7748 30.9629 10.8463 29.7509 9.8248 30.0464C9.72673 30.0748 9.64124 30.1357 9.58236 30.2191C9.52349 30.3026 9.49472 30.4035 9.5008 30.5054L9.5308 30.9944L11.5498 31.3379Z"
         fill="#DABFF5"
         stroke="#45413C"
         stroke-width="0.3"
         stroke-linecap="round"
         stroke-linejoin="round"
       />
       <path
         d="M11.5487 31.338C11.5487 31.338 10.7117 31.6815 9.61371 31.125C9.58592 31.1119 9.56279 31.0907 9.54744 31.0641C9.5321 31.0376 9.52527 31.0069 9.52789 30.9763C9.53051 30.9458 9.54244 30.9167 9.56207 30.8931C9.58171 30.8696 9.60811 30.8526 9.63771 30.8445C9.97108 30.746 10.3249 30.7399 10.6615 30.8269C10.998 30.9138 11.3047 31.0904 11.5487 31.338Z"
         fill="#BF8DF2"
         stroke="#45413C"
         stroke-width="0.3"
         stroke-linecap="round"
         stroke-linejoin="round"
       />
       <path
         d="M12.4555 31.3379L12.2305 30.9629C12.2305 30.9629 13.159 29.7509 14.1805 30.0464C14.2774 30.0759 14.3616 30.1373 14.4193 30.2206C14.477 30.3039 14.5049 30.4043 14.4985 30.5054L14.467 30.9944L12.4555 31.3379Z"
         fill="#DABFF5"
         stroke="#45413C"
         stroke-width="0.3"
         stroke-linecap="round"
         stroke-linejoin="round"
       />
       <path
         d="M12.457 31.338C12.457 31.338 13.2865 31.6815 14.3845 31.125C14.4123 31.1119 14.4354 31.0907 14.4508 31.0641C14.4661 31.0376 14.473 31.0069 14.4703 30.9763C14.4677 30.9458 14.4558 30.9167 14.4362 30.8931C14.4165 30.8696 14.3901 30.8526 14.3605 30.8445C14.0282 30.7475 13.6759 30.7422 13.3408 30.829C13.0057 30.9159 12.7004 31.0917 12.457 31.338Z"
         fill="#BF8DF2"
         stroke="#45413C"
         stroke-width="0.3"
         stroke-linecap="round"
         stroke-linejoin="round"
       />
       <path
         d="M12.3555 31.2059C12.3555 31.2059 13.4475 31.5419 13.6845 32.3459L13.146 32.2529L12.978 32.7944C12.978 32.7944 12.4695 31.5704 11.9985 31.3949L12.3555 31.2059ZM11.6415 31.2059C11.6415 31.2059 10.5495 31.5419 10.3125 32.3459L10.851 32.2529L11.019 32.7944C11.019 32.7944 11.5275 31.5659 11.9985 31.3904L11.6415 31.2059Z"
         fill="#BF8DF2"
         stroke="#45413C"
         stroke-width="0.3"
         stroke-linecap="round"
         stroke-linejoin="round"
       />
       <path
         d="M11.3242 31.02C11.3242 31.1592 11.3953 31.2928 11.5219 31.3912C11.6485 31.4897 11.8202 31.545 11.9992 31.545C12.1782 31.545 12.3499 31.4897 12.4765 31.3912C12.6031 31.2928 12.6742 31.1592 12.6742 31.02C12.6742 30.8808 12.6031 30.7472 12.4765 30.6488C12.3499 30.5503 12.1782 30.495 11.9992 30.495C11.8202 30.495 11.6485 30.5503 11.5219 30.6488C11.3953 30.7472 11.3242 30.8808 11.3242 31.02Z"
         fill="#BF8DF2"
       />
       <path
         d="M11.9992 30.795C12.1315 30.7869 12.2633 30.8182 12.3778 30.8849C12.4924 30.9517 12.5845 31.0509 12.6427 31.17C12.6622 31.1223 12.6729 31.0715 12.6742 31.02C12.6742 30.729 12.3742 30.495 11.9992 30.495C11.6242 30.495 11.3242 30.729 11.3242 31.02C11.3256 31.0715 11.3362 31.1223 11.3557 31.17C11.4139 31.0509 11.5061 30.9517 11.6206 30.8849C11.7351 30.8182 11.8669 30.7869 11.9992 30.795Z"
         fill="#DABFF5"
       />
       <path
         d="M11.3242 31.02C11.3242 31.1592 11.3953 31.2928 11.5219 31.3912C11.6485 31.4897 11.8202 31.545 11.9992 31.545C12.1782 31.545 12.3499 31.4897 12.4765 31.3912C12.6031 31.2928 12.6742 31.1592 12.6742 31.02C12.6742 30.8808 12.6031 30.7472 12.4765 30.6488C12.3499 30.5503 12.1782 30.495 11.9992 30.495C11.8202 30.495 11.6485 30.5503 11.5219 30.6488C11.3953 30.7472 11.3242 30.8808 11.3242 31.02Z"
         stroke="#45413C"
         stroke-width="0.3"
         stroke-linecap="round"
         stroke-linejoin="round"
       />
     </svg>

     <h5 class="block mb-2  font-montserratbold text-xl antialiased font-semibold leading-snug tracking-normal text-white">
       40 LUCKY WINNERS
     </h5>
     <p class="block  font-montserrat-reg ls-2 antialiased leading-relaxed text-inherit">
       will receive their dream nail color delivered to their doorstep!
     </p>
   </div>
 </div>
 <div class="relative flex flex-col mt-6 text-white bg-orange-500 shadow-md bg-clip-border rounded-xl ">
   <div class="p-6">
     <svg
       xmlns="http://www.w3.org/2000/svg"
       viewBox="0 0 48 48"
       className="w-20 h-20 mb-4"
     >
       <path
         fill="#45413c"
         d="M5.06 44.5a14.21 1.5 0 1 0 28.42 0a14.21 1.5 0 1 0-28.42 0"
         opacity=".15"
       />
       <path
         fill="#ff866e"
         d="m19.11 30.76l-13-6.39L4.52 37.3a.76.76 0 0 0 .43.78l12.55 6.16a3.1 3.1 0 0 0 2 .24l13.65-3a.79.79 0 0 0 .6-.67l1.55-12.93L21.15 31a3.12 3.12 0 0 1-2.04-.24"
       />
       <path
         fill="#ff6242"
         d="M21.15 31a3.12 3.12 0 0 1-2-.25l-13-6.39l-.55 3.86l13.05 6.39a3.1 3.1 0 0 0 2 .25l14.19-3.14l.46-3.85Z"
       />
       <path
         fill="none"
         stroke="#45413c"
         stroke-linecap="round"
         stroke-linejoin="round"
         d="m19.11 30.76l-13-6.39L4.52 37.3a.76.76 0 0 0 .43.78l12.55 6.16a3.1 3.1 0 0 0 2 .24l13.65-3a.79.79 0 0 0 .6-.67l1.55-12.93L21.15 31a3.12 3.12 0 0 1-2.04-.24"
       />
       <path
         fill="none"
         stroke="#e04122"
         stroke-linecap="round"
         stroke-linejoin="round"
         d="m18.66 43.18l1.24-10.4"
       />
       <path
         fill="#e04122"
         stroke="#45413c"
         stroke-linecap="round"
         stroke-linejoin="round"
         d="m35.33 27.87l-13-6.4a3.12 3.12 0 0 0-2-.24L6.06 24.37l13.05 6.39a3.12 3.12 0 0 0 2 .25Z"
       />
       <path
         fill="#eddbff"
         d="M9.02 25.81L7.4 39.29l6.64 3.26l1.62-13.48z"
       />
       <path
         fill="#dabff5"
         d="m9.02 25.81l-.47 3.85l6.65 3.26l.46-3.85z"
       />
       <path
         fill="none"
         stroke="#45413c"
         stroke-linecap="round"
         stroke-linejoin="round"
         d="M9.02 25.81L7.4 39.29l6.64 3.26l1.62-13.48z"
       />
       <path
         fill="#eddbff"
         d="m32.12 28.58l-1.61 13.48l-7.22 1.59l1.61-13.47z"
       />
       <path
         fill="#dabff5"
         d="m32.12 28.58l-.46 3.85l-7.22 1.6l.46-3.85z"
       />
       <path
         fill="none"
         stroke="#45413c"
         stroke-linecap="round"
         stroke-linejoin="round"
         d="m32.12 28.58l-1.61 13.48l-7.22 1.59l1.61-13.47z"
       />
       <path
         fill="#ff866e"
         d="m16.53 18.93l-15.3-1.24l1.24 4.72a.76.76 0 0 0 .69.57l14.75 1.2a3.09 3.09 0 0 0 2-.52l12.26-8.26a.8.8 0 0 0 .32-.84l-1.24-4.72l-12.73 8.57a3.18 3.18 0 0 1-1.99.52"
       />
       <path
         fill="#ffa694"
         d="M18.52 18.41a3.18 3.18 0 0 1-2 .52L1.23 17.69l.59 2.25l15.3 1.24a3.19 3.19 0 0 0 2-.52l12.73-8.57l-.59-2.25Z"
       />
       <path
         fill="none"
         stroke="#45413c"
         stroke-linecap="round"
         stroke-linejoin="round"
         d="m16.53 18.93l-15.3-1.24l1.24 4.72a.76.76 0 0 0 .69.57l14.75 1.2a3.09 3.09 0 0 0 2-.52l12.26-8.26a.8.8 0 0 0 .32-.84l-1.24-4.72l-12.73 8.57a3.18 3.18 0 0 1-1.99.52"
       />
       <path
         fill="#ff866e"
         stroke="#45413c"
         stroke-linecap="round"
         stroke-linejoin="round"
         d="M1.23 17.69L14 9.11a3.08 3.08 0 0 1 2-.51l15.3 1.24l-12.78 8.57a3.18 3.18 0 0 1-2 .52Z"
       />
       <path
         fill="#eddbff"
         stroke="#45413c"
         stroke-linecap="round"
         stroke-linejoin="round"
         d="M18.28 8.78L4.51 17.95l1.37 5.26l7.38.59l-1.38-5.25l13.77-9.17z"
       />
       <path
         fill="none"
         stroke="#bf8df2"
         stroke-linecap="round"
         stroke-linejoin="round"
         d="m6.7 18.13l3.72.3"
       />
       <path
         fill="#eddbff"
         stroke="#45413c"
         stroke-linecap="round"
         stroke-linejoin="round"
         d="m12.03 10.42l16.49 1.25l1.38 5.25l-6.14 4.13l-1.37-5.25L5.9 14.55z"
       />
       <path
         fill="none"
         stroke="#bf8df2"
         stroke-linecap="round"
         stroke-linejoin="round"
         d="m26.7 12.9l-3.09 2.08"
       />
       <path
         fill="#dabff5"
         stroke="#45413c"
         stroke-linecap="round"
         stroke-linejoin="round"
         d="m18.9 13.6l-1.84-1.31s2-8 7.46-8.66A2.3 2.3 0 0 1 27 5.15l.86 2.35Z"
       />
       <path
         fill="#bf8df2"
         stroke="#45413c"
         stroke-linecap="round"
         stroke-linejoin="round"
         d="M18.9 13.6s4.74-.37 8.81-5.28A.78.78 0 0 0 27 7a10.27 10.27 0 0 0-8.1 6.6"
       />
       <path
         fill="#dabff5"
         stroke="#45413c"
         stroke-linecap="round"
         stroke-linejoin="round"
         d="m14 15l.81-2.11S9 7.56 4.05 10a2.31 2.31 0 0 0-1.19 2.62l.59 2.44Z"
       />
       <path
         fill="#bf8df2"
         stroke="#45413c"
         stroke-linecap="round"
         stroke-linejoin="round"
         d="M14 15s-3.9 2.51-10 .68a.78.78 0 0 1-.13-1.45A9.91 9.91 0 0 1 14 15"
       />
       <path
         fill="#bf8df2"
         stroke="#45413c"
         stroke-linecap="round"
         stroke-linejoin="round"
         d="M14.5 14.3s-5.1 3-5.36 7.29l2.6-1.1l1.49 2.56s1.12-6.78 3.29-8.22Zm3.56-.88s5.9.25 8.14 4l-2.81.24l-.13 2.95s-4.15-5.48-6.74-5.75Z"
       />
       <path
         fill="#bf8df2"
         d="M19.41 12.07c.38 1.45-.83 3-2.69 3.51s-3.69-.29-4.06-1.74s.82-3 2.69-3.51s3.65.29 4.06 1.74"
       />
       <path
         fill="#dabff5"
         d="M15.74 11.83a3.46 3.46 0 0 1 3.71 1a2.16 2.16 0 0 0 0-.8c-.38-1.45-2.2-2.23-4.06-1.74s-3.07 2.06-2.69 3.51a2 2 0 0 0 .35.71a3.47 3.47 0 0 1 2.69-2.68"
       />
       <path
         fill="none"
         stroke="#45413c"
         stroke-linecap="round"
         stroke-linejoin="round"
         d="M19.41 12.07c.38 1.45-.83 3-2.69 3.51s-3.69-.29-4.06-1.74s.82-3 2.69-3.51s3.65.29 4.06 1.74"
       />
       <path
         fill="#00f5bc"
         stroke="#45413c"
         stroke-linecap="round"
         stroke-linejoin="round"
         d="M29.33 26.48a4.66 4.66 0 0 1-3.83 2.17l-1.36-2.39A4.67 4.67 0 0 0 28 24.08Z"
       />
       <path
         fill="#ff6242"
         stroke="#45413c"
         stroke-linecap="round"
         stroke-linejoin="round"
         d="M45 9.18a4.69 4.69 0 0 1-2 4l-2.47-1.21a4.69 4.69 0 0 0 1.94-4Z"
       />
       <path
         fill="#ff6196"
         stroke="#45413c"
         stroke-linecap="round"
         stroke-linejoin="round"
         d="M39.55 47a4.68 4.68 0 0 1-.93-4.31l2.7-.58a4.7 4.7 0 0 0 .92 4.31Z"
       />
       <path
         fill="#ff8a14"
         stroke="#45413c"
         stroke-linecap="round"
         stroke-linejoin="round"
         d="M47.5 25.53a4.68 4.68 0 0 1-4.23 1.24l-.78-2.64a4.68 4.68 0 0 0 4.23-1.25Z"
       />
       <path
         fill="#4aeff7"
         stroke="#45413c"
         stroke-linecap="round"
         stroke-linejoin="round"
         d="M36.54 32.53a4.7 4.7 0 0 1 3.81 2.23L39 37.14a4.66 4.66 0 0 0-3.8-2.23Z"
       />
       <path
         fill="#fff48c"
         stroke="#45413c"
         stroke-linecap="round"
         stroke-linejoin="round"
         d="M30 44.7a4.7 4.7 0 0 1-4.18-1.41l.89-2.61a4.65 4.65 0 0 0 4.17 1.41Zm2.82-23.16a4.7 4.7 0 0 1 2.86-3.36l2.1 1.82a4.68 4.68 0 0 0-2.86 3.36Z"
       />
     </svg>

     

     <h5 class="block mb-2  font-montserratbold text-xl antialiased font-semibold leading-snug tracking-normal text-white">
       ONE MEGA WINNER
     </h5>
     <p class="block  font-montserrat-reg ls-2 antialiased leading-relaxed text-inherit">
       From the shortlisted 40 lucky winners,
       <span className="mr-1 font-montserratbold"> ONE</span> will be
       eligible to become
       <span className="ml-1 font-montserratbold">
         THE FACE OF JUICE
       </span>
     </p>
   </div>
 </div>
</div>

<div className=" text-[#808080] pt-6 flex flex-col justify-center text-center">
 <p class=" font-montserrat text-base">
   To increase your chances of winning <br />
   <span className="text-lg">
     Follow{" "}
     <a
       href="https://www.instagram.com/juicecosmetics/"
       target="_blank"
       rel="noopener noreferrer"
       className=" font-montserratbold bg-gradient-to-br from-[#7a0242] via-[#f32d9a] via-[#dc497a]  to-[#4dfc03] inline-block text-transparent bg-clip-text hover:underline"
     >
       @JUICECOSMETICS
     </a>{" "}
     on INSTAGRAM
   </span>
   !
 </p>
 <p className="text-xs font-montserrat-reg text-center mt-4">
For queries, mail us at <br/>
<a href="mailto:care@juicecosmetics.in" className="underline">care@juicecosmetics.in</a>
</p>

</div>
        </div>
        </div>
        </div>
{showModal && (
  
           <div className="fixed inset-0 z-50 overflow-y-auto">
           <div className="flex items-center justify-center min-h-screen p-2 text-center">
             <div className="fixed inset-0 transition-opacity" aria-hidden="true">
               <div className="absolute inset-0 bg-gray-500 opacity-75"></div>
             </div>
             <span className="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">
               &#8203;
             </span>
             <div className="flex flex-wrap mb-5">
               <div className="w-full mb-6 mx-auto">
                 <div className="relative  flex flex-col break-words  bg-clip-border rounded-xl bg-white my-5">
                   <div className="relative flex flex-col   rounded-2xl bg-light/30">
                     <div className="px-4 pt-5 flex justify-between items-stretch flex-wrap  pb-0 bg-transparent">
                       <h3 className="flex flex-col items-start justify-center  font-medium text-xl text-dark">
                         <span className="font-montserratbold bg-gradient-to-br from-[#7a0242] via-[#f32d9a] via-[#f7568b]  to-[#4dfc03] text-transparent bg-clip-text   text-2xl text-center">Winners List</span>
                       </h3>
                       <button
                         onClick={() => setShowModal(false)}
  
                         className="text-gray-500 hover:text-gray-700 font-montserrat-reg transition-colors duration-200 ease-in-out justify-end"
                         aria-label="Close"
                       >
                         <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                           <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12"></path>
                         </svg>
                       </button>
                     </div>
                     <div className="flex-auto block py-8 pt-6 px-16">
                       <div className="overflow-x-auto">
                         <table className="w-full my-0 align-middle text-dark border-neutral-200">
                           <thead className="align-bottom">
                             <tr className="font-bold font-montserrat-reg text-secondary-dark">
                               {/* <th className="pb-3 text-start min-w-[175px]">NAME</th> */}
                               {/* <th className="pb-3 text-end">LOCATION</th> */}
                             </tr>
                           </thead> 
                           <tbody>
                             {winnersList.map((winner, index) => (
                               <tr key={index} className="border-b border-dashed last:border-b-0">
                                 <td className="p-3 pl-0">
                                   <div className="flex items-center">
                                     <div className="relative inline-block shrink-0 rounded-2xl mr-3">
                                       <img src={winner.imgurl} className="w-[40px] h-[40px] inline-block shrink-0 rounded-full" alt={winner.name} />
                                     </div>
                                     <div className="flex flex-col justify-start">
                                       <a href="javascript:void(0)" className="mb-1 text-xs font-montserrat-reg transition-colors duration-200 ease-in-out font-mon text-secondary-inverse hover:text-primary">
                                         &nbsp;{winner.name}
                                       </a>
                                       <span className=" text-light text-start text-[10px] font-montserrat-reg">{winner.location}</span>

                                     </div>
                                   </div>
                                 </td>
                                 {/* <td className="p-3 pr-0 text-center">
                                 <span class="text-center text-xs align-baseline inline-flex px-3 py-2 mr-auto items-center font-montserrat-reg leading-none text-primary bg-blue-200 rounded-lg">{winner.color}</span>
                                                   </td> */}
                               </tr>
                             ))}
                           </tbody>
                         </table>
                       </div>
                     </div>
                   </div>
                 </div>
               </div>
             </div>
           </div>
         </div>
      )}




            

     
     
    </>
  );
}
const getButtonPosition = (index) => {
  switch (index) {
    case 0:
      return "left-[35px] -top-[2px]";
    case 1:
      return "right-[35px] -top-[2px]";
    case 2:
      return "-left-4 top-20";
    case 3:
      return "-right-4 top-20";
    case 4:
      return "bottom-0 left-10";
    case 5:
      return "bottom-20 -right-5";
    case 6:
      return "right-[40%] -bottom-4";
    case 7:
      return "left-[42%] bottom-64";
    case 8:
      return "right-[10%] bottom-0";
    case 9:
      return "top-[60%] -left-4";
    default:
      return ""; // Default position
  }
};

export default Contest;
